





























































































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {IOrganization, OrchestratorAuthType} from "@/interfaces/organization.interface";

@Component
export default class EditOrganization extends Vue {
  @Prop() organization!: IOrganization;

  editableOrga: IOrganization | null = null;
  readonly authTypeOptions: OrchestratorAuthType[] = [
    OrchestratorAuthType.API_KEY, 
    OrchestratorAuthType.TECHNICAL_USER, 
    OrchestratorAuthType.CONFIDENTIAL_CLIENT
  ];
  readonly technicalUserAuthType: OrchestratorAuthType = 
    OrchestratorAuthType.TECHNICAL_USER;
  readonly apiKeyAuthType: OrchestratorAuthType = OrchestratorAuthType.API_KEY;
  readonly confidentialClientAuthType: OrchestratorAuthType = 
    OrchestratorAuthType.CONFIDENTIAL_CLIENT;

  created(): void {
    this.makeEditCopy(this.organization);
  }

  makeEditCopy(org: IOrganization) {
    this.editableOrga = JSON.parse(JSON.stringify(org));
  }

  orchestratorDataChanged() {
    if (this.editableOrga && this.editableOrga.orchestratorConfig) {
      this.editableOrga.orchestratorConfig.orchestratorConnectionSuccess = false;
    }
  }

  @Emit("editedOrganization")
  emitChanges() {
    return this.editableOrga;
  }

  @Watch("organization")
  onOrganizationChange(newValue: IOrganization) {
    this.makeEditCopy(newValue);
  }
}
